import styled from "styled-components";

export const ProductsCarouselContainer = styled.div`
  display: flex;
  position: relative;
  width: max-content;
  gap: 2rem;

  @media (max-width: 1200px) {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 768px) {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    justify-content: space-around;
    gap: 1rem;
  }

  @media (max-width: 600px) {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    justify-content: space-around;
    gap: 1rem;
  }

  .arrowLeft {
    position: absolute;
    top: 45%;
    left: -1.5rem;

    @media (max-width: 1200px) {
      display: none;
    }
  }

  .arrowRight {
    position: absolute;
    right: -1.5rem;
    top: 45%;

    @media (max-width: 1200px) {
      display: none;
    }
  }
`;
